import { defineSlotRecipe } from '@chakra-ui/react'
import { checkboxAnatomy } from '@chakra-ui/react/anatomy'

export const checkboxSlotRecipe = defineSlotRecipe({
    slots: checkboxAnatomy.keys(),
    variants: {
        variant: {
            gsk: {
                control: {
                    height: '18px',
                    width: '18px',
                    backgroundColor: 'transparent',

                    _light: {
                        borderColor: 'dark.700',
                        _checked: {
                            backgroundColor: 'dark.700',
                            borderColor: 'dark.700',
                            _hover: {
                                backgroundColor: 'dark.700',
                                borderColor: 'dark.700',
                            },
                        },
                        _disabled: {
                            backgroundColor: 'transparent',
                            borderColor: 'dark.700',
                            _checked: {
                                backgroundColor: 'dark.700',
                                borderColor: 'dark.700',
                            },
                        },
                        _indeterminate: {
                            backgroundColor: 'dark.700',
                            borderColor: 'dark.700',
                        },
                    },
                    _dark: {
                        borderColor: 'white',
                        _checked: {
                            backgroundColor: 'white',
                            borderColor: 'white',
                            _hover: {
                                backgroundColor: 'white',
                                borderColor: 'white',
                            },
                        },
                        _disabled: {
                            backgroundColor: 'transparent',
                            borderColor: 'white',
                            _checked: {
                                backgroundColor: 'white',
                                borderColor: 'white',
                            },
                        },
                        _indeterminate: {
                            backgroundColor: 'white',
                            borderColor: 'white',
                        },
                    },
                },
                label: {
                    _light: {
                        color: 'dark.700',
                    },
                    _dark: {
                        color: 'white',
                    },
                    _disabled: {
                        opacity: 1,
                        _checked: {
                            opacity: 1,
                        },
                    },
                },
                indicator: {
                    _dark: {
                        color: 'dark.700',
                    },
                },
            },
        },
    },
})
